import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import React from "react";

function BillingSDWANDetails({ sdWan }) {
  return (
    <>
      <MDBTable>
        <MDBTableHead>
          <tr>
            <th scope="col">Productname (Quote ID)</th>
            <th scope="col">Quantity</th>
            <th scope="col">Price</th>
            <th scope="col">Net Total</th>
            <th scope="col">Start Date</th>
            <th scope="col">End Date</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {sdWan &&
            sdWan.length > 0 &&
            sdWan.forEach((info) => (
              <>
                <tr>
                  <td scope="row">{info.product_name}</td>
                  <td scope="row">{info.quantity}</td>
                  <td scope="row">{info.price}</td>
                  <td scope="row">{info.net_total}</td>
                  <td scope="row">{info.start_date}</td>
                  <td scope="row">{info.end_date}</td>
                </tr>
              </>
            ))}
        </MDBTableBody>
      </MDBTable>
    </>
  );
}

export default BillingSDWANDetails;
